import React, { useContext } from 'react';
import CollectionsContext from '../../hooks/@lore/query-connect/contexts/CollectionsContext';

export default function useCollections() {
  return useContext(CollectionsContext);
}
